/* eslint-disable no-param-reassign */
import Vue from "vue";
import baseURL from "@/api/http-common";

let userObj =
  localStorage.getItem("telasUserObj") !== null &&
  localStorage.getItem("telasUserObj").length > 0
    ? JSON.parse(localStorage.getItem("telasUserObj"))
    : "";
const reportsState = {
  comparativeReady: {},
  combinedReviews: {
    assigned: {},
    inProgress: {},
    completed: {},
    accredited: {},
    testAccreditation: {},
    all: {},
  },
  accreditationCalcDetail: {},
};
const getters = {
  // eslint-disable-next-line max-len
  assignedReportMeta: (state) =>
    Object.values(state.combinedReviews.assigned).map(
      (report) => report.report_details
    ),
  // eslint-disable-next-line max-len
  inProgressReportMeta: (state) =>
    Object.values(state.combinedReviews.inProgress).map(
      (report) => report.report_details
    ),
  // eslint-disable-next-line max-len
  accreditedReportMeta: (state) =>
    Object.values(state.combinedReviews.accredited).map(
      (report) => report.report_details
    ),
  // eslint-disable-next-line max-len
  completedReportMeta: (state) =>
    Object.values(state.combinedReviews.completed).map(
      (report) => report.report_details
    ),
  // eslint-disable-next-line max-len
  testAccreditationReportMeta: (state) =>
    Object.values(state.combinedReviews.testAccreditation).map(
      (report) => report.report_details
    ),
  // eslint-disable-next-line max-len
  allReportMeta: (state) =>
    Object.values(state.combinedReviews.all).map(
      (report) => report.report_details
    ),
  pendingReports: (state) =>
    Object.values(state.combinedReviews.inProgress).filter(
      (report) => report.report_details.is_pending === "yes"
    ),
};
const actions = {
  async initiateReassessment({ commit, rootState }, reportID) {
    console.log("initiateReassessment");
    commit("LOADING", { rootState });
    try {
      console.log("endpoint:", `${baseURL}duplicator/v1/report/${reportID}`);
      const userToken = rootState.user.userDetails.token;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}duplicator/v1/report/${reportID}`,
        {},
        options
      );
      const actualData = response.data;

      console.log(actualData);
      // Assuming successful initiation of reassessment
      commit("REASSESSMENT_INITIATED", { actualData, rootState });
    } catch (error) {
      commit("REASSESSMENT_ERROR", { error });
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async getComparativeReadyCourses({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-courses?per_page=100`,
        { params: data }
      );
      const actualData = response.data;

      commit("GETCOMPARATIVEREADYCOURSES", { actualData, rootState, origin });
    } catch (error) {
      if (error.respone.data.length) {
        const actualData = error.response.data;
        commit("GETCOMPARATIVEREADYCOURSESERROR", {
          actualData,
          rootState,
          origin,
        });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async getCombinedReports({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-courses?per_page=100`,
        { params: data }
      );
      const actualData = response.data;
      commit("GETCOMBINEDREPORTS", { actualData, rootState, origin });
    } catch (error) {
      if (error.respone.data.length) {
        const actualData = error.response.data;
        commit("GETCOMPARATIVEREADYCOURSESERROR", {
          actualData,
          rootState,
          origin,
        });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async getAccreditationByReportId({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}extended-telasweb/v1/assessment-calc/${data}`,
        data
      );
      const actualData = response.data;
      commit("GETACCREDITATIONCALC", { actualData });
    } catch (error) {
      commit("GETACCREDITATIONERROR", { error });
    }
    commit("ENDLOADING", { rootState });
  },
  async sendAccreditation({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/send-accreditation`,
        data,
        options
      );
      const actualData = response.data;
      commit("SENDACCREDITATION", { actualData, rootState });
    } catch (error) {
      commit("SENDACCREDITATIONERROR", { error });
    }
    commit("ENDLOADING", { rootState });
  },
  async getReports({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-report?per_page=100`,
        { params: data }
      );
      const actualData = response.data;
      const { reviewStatus } = data;
      commit("GETREPORT", { actualData, reviewStatus });
    } catch (error) {
      commit("GETREPORTERROR", { error });
    }
    commit("ENDLOADING", { rootState });
  },
};
const mutations = {
  REASSESSMENT_INITIATED(state, { actualData, rootState }) {
    if (actualData.status === 200) {
      rootState.common.messages.success = actualData.message;
      window.location.reload(); // Add this line to reload the page
    } else {
      rootState.common.messages.errors = actualData.message;
    }
  },
  REASSESSMENT_ERROR(state, { error }) {
    //state.reassessmentError = error.message; // Assuming you want to store the error message
  },
  GETCOMPARATIVEREADYCOURSES(state, { actualData }) {
    reportsState.comparativeReady = actualData;
  },
  GETREPORT(state, { actualData, reviewStatus }) {
    switch (reviewStatus) {
      case "assigned":
        reportsState.combinedReviews.assigned = actualData;
        break;
      case "in-progress":
        reportsState.combinedReviews.inProgress = actualData;
        break;
      case "completed":
        reportsState.combinedReviews.completed = actualData;
        break;
      case "fortest":
        reportsState.combinedReviews.testAccreditation = actualData;
        break;
      case "accredited":
        reportsState.combinedReviews.accredited = actualData;
        break;
      default:
        reportsState.combinedReviews.all = actualData;
        break;
    }
  },
  SENDACCREDITATION(state, { actualData, rootState }) {
    if (actualData.status === 200) {
      rootState.common.messages.success = actualData.message;
      rootState.assessments.combinedReview.report_details.accreditation_email_sent =
        "yes";
    } else {
      rootState.common.messages.errors = actualData.message;
      rootState.assessments.combinedReview.report_details.accreditation_email_sent =
        "no";
    }
  },
  // eslint-disable-next-line no-unused-vars
  SENDACCREDITATIONERROR(state, { actualData, rootState }) {},
  GETCOMBINEDREPORTS(state, { actualData }) {
    reportsState.combinedReviews = actualData;
  },
  GETACCREDITATIONCALC(state, { actualData }) {
    reportsState.accreditationCalcDetail = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  GETCOMPARATIVEREADYCOURSESERROR(state, { actualData, rootState }) {
    // rootState.courses.courseDetails = actualData;
  },
  /* eslint-disable no-unused-vars */
  GETACCREDITATIONERROR(state, { error }) {},
  GETREPORTERROR(state, { error }) {},
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
};

export default {
  namespaced: true,
  state: reportsState,
  getters,
  actions,
  mutations,
};
